import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/layout/Header';
import BottomNav from './components/layout/BottomNav';
import CourseList from './pages/courses/CourseList';
import CourseDetail from './pages/courses/CourseDetail';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import MyRegistrations from './pages/user/MyRegistrations';
import AdminDashboard from './pages/admin/AdminDashboard';
import CourseManagement from './pages/admin/CourseManagement';
import OrderManagement from './pages/admin/OrderManagement';
import TeacherRosterPage from './pages/admin/TeacherRosterPage';
import MyPage from './pages/user/MyPage';
import ProfilePage from './pages/user/ProfilePage';
import ChangePasswordPage from './pages/user/ChangePasswordPage';
import OrdersPage from './pages/user/OrdersPage';
import CouponsPage from './pages/user/CouponsPage';
import FavoritesPage from './pages/user/FavoritesPage';
import AddressPage from './pages/user/AddressPage';
import MyCoursesPage from './pages/user/MyCoursesPage';
import TransferPage from './pages/user/TransferPage';
import RenewPage from './pages/user/RenewPage';
import CalendarPage from './pages/user/CalendarPage';
import OCRPage from './pages/OCRPage';
import ProtectedRoute from './components/common/ProtectedRoute';
import './App.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Navigate to="/courses" replace />} />
            <Route path="/courses" element={<CourseList />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/my" element={<MyPage />} />
            <Route 
              path="/my/profile" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/change-password" 
              element={
                <ProtectedRoute>
                  <ChangePasswordPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/orders" 
              element={
                <ProtectedRoute>
                  <OrdersPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/coupons" 
              element={
                <ProtectedRoute>
                  <CouponsPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/favorites" 
              element={
                <ProtectedRoute>
                  <FavoritesPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/address" 
              element={
                <ProtectedRoute>
                  <AddressPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/courses" 
              element={
                <ProtectedRoute>
                  <MyCoursesPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/transfer" 
              element={
                <ProtectedRoute>
                  <TransferPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/renew" 
              element={
                <ProtectedRoute>
                  <RenewPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my/calendar" 
              element={
                <ProtectedRoute>
                  <CalendarPage />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/my-registrations" 
              element={
                <ProtectedRoute>
                  <MyRegistrations />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/courses" 
              element={
                <ProtectedRoute requireAdmin>
                  <CourseManagement />
                </ProtectedRoute>
              }
            />
            <Route 
              path="/admin/orders" 
              element={
                <ProtectedRoute requireAdmin>
                  <OrderManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/teacher-rosters"
              element={
                <ProtectedRoute>
                  <TeacherRosterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teacher-students"
              element={
                <ProtectedRoute>
                  <TeacherRosterPage />
                </ProtectedRoute>
              }
            />
            <Route path="/teacher-rosters" element={<Navigate to="/teacher-students" replace />} />
            <Route path="/ocr" element={<OCRPage />} />
          </Routes>
          <BottomNav />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
